import { FunctionComponent } from "react";

import { useTranslation } from "../../TranslationContext";

const Services: FunctionComponent = () => {
  const translations = useTranslation();
  return (
    <div
      id="services"
      className="relative bg-white w-full flex flex-col p-24 pb-0 box-border items-center justify-start gap-14 text-center text-4xl text-nebula-950 font-text-sm-font-medium lg:px-6 md:py-10 xs:px-4 md:pb-4 xs:text-3xl"
    >
      <div className="self-stretch flex flex-col items-center justify-start gap-[24px]">
        <div className="self-stretch flex flex-col items-center justify-start gap-[16px]">
          <div className="self-stretch relative leading-[150%] font-extrabold">
            <h1>{translations.services.title}</h1>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Services;
